import { EnrolCheckModel } from "@/composables/enrolement";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface EnrolementStoreType {
  enrol: EnrolCheckModel | null;
  setEnrol: (enrol: EnrolCheckModel | null) => void;
}

export const useEnrolementStore = create<EnrolementStoreType>()(
  persist(
    (set, get) => ({
      enrol: null,
      setEnrol: (enrol: EnrolCheckModel | null) => set({ enrol }),

      clearStore: () => {
        set({
          enrol: null,
        });
        localStorage.removeItem("enrolement-store");
      },
    }),
    {
      name: "enrolement-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
